import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {fetchAllBanks, fetchEmploymentStatus, fetchFinancier, fetchPrecustomerByMsisdn, fetchRepaymentSetupLink, verifyBundleActivation,
    fetchPrecustomerByMsisdnAndEmail, fetchAllDevices, fetchDeviceByCreditLimit, fetchFBNDeviceByTenure, fbnFetchMoreDevices,
} from "../../../services/oxygenRetailServices";
import {getPrecustomerDetails} from "../../../services/PrequalificationService";


const initialState = {
    loading: false,
    error: "",
    customermsisdn:"",
    preCustomerId: "",
    allBanks: [],
    employmentStatus: [],
    financiers: [],
    preCustomerDetailsByMsisdn:[],
    preCustomerDetailsByMsisdnAndEmail:[],
    bookloanDetails:"",
    repaymentSetupLink:[],
    verifyBundleStatus: null,
    // nextOfKinDetails:[],
    bookloanLoading: false,
    otpLoading: false,
    phoneNo:"",
    emailAddress:"",
    showForm:false,
    preCustomerDetailsByPreCustomerId:[],
    useLivenessCheck : "smileId",    
    allDevices:[],
    selectedDevice:null,
    devicesParams:{
        Filter:"",
        PageSize:"30",
        PageNumber:"1",
    },
    tabValue:'Default',
    bypassSmileIdLiveCheck: true,
    fbnDeviceByTenure: [],
};


export const getAllBanks = createAsyncThunk(
    "oxygenRetail/getAllBanks",
    async () => {
        return await fetchAllBanks();
    }
);

export const getEmploymentStatus = createAsyncThunk(
    "oxygenRetail/getEmploymentStatus",
    async () => {
        return await fetchEmploymentStatus();
    }
);

export const getFinancier = createAsyncThunk(
    "oxygenRetail/getFinancier",
    async () => {
        return await fetchFinancier();
    }
);

export const getPreCustomerByMsisdn = createAsyncThunk(
    "oxygenRetail/getPreCustomerByMsisdn",
    async (msisdn) => {
        return await fetchPrecustomerByMsisdn(msisdn);
    }
);

export const getPreCustomerByMsisdnAndEmail = createAsyncThunk(
    "oxygenRetail/getPreCustomerByMsisdnAndEmail",
    async (payload) => {
        return await fetchPrecustomerByMsisdnAndEmail(payload);
    }
);

export const getRepaymentSetupLink = createAsyncThunk(
    "oxygenRetail/getRepaymentSetupLink",
    async (preCustomerId) => {
        return await fetchRepaymentSetupLink(preCustomerId);
    }
);

export const getVerifyBundleActivation = createAsyncThunk(
    "oxygenRetail/getVerifyBundleActivation",
    async (msisdn) => {  
        return await verifyBundleActivation(msisdn);
    }
);

export const getPrecustomerDetailsByPreCustomerId = createAsyncThunk(
    "oxygenRetail/getPrecustomerDetailsPreCustomerId",
    async (preCustomerId) => {
        return await getPrecustomerDetails(preCustomerId);
    }
);

export const getAllDevices = createAsyncThunk(
    "oxygenRetail/getAllDevices",
    async (arg, {getState}) => {
        return await fetchAllDevices(getState()?.oxygenRetail?.devicesParams);
    }
);

export const getDeviceByCreditLimit = createAsyncThunk(
    "oxygenRetail/getDeviceByCreditLimit",
    async (arg, {getState}) => {
        return await fetchDeviceByCreditLimit(arg, getState()?.oxygenRetail?.devicesParams);
    }
);

export const getFBNDeviceByTenure = createAsyncThunk(
    "oxygenRetail/getDeviceByTenure",
    async (arg, {getState}) => {
        return await fetchFBNDeviceByTenure(arg, getState()?.oxygenRetail?.devicesParams);
    }
);

export const getFBNFetchMoreDevices = createAsyncThunk(
    "oxygenRetail/getFBNFetchMoreDevices",
    async (arg, {getState}) => {
        return await fbnFetchMoreDevices(arg, getState()?.oxygenRetail?.devicesParams);
    }
);



const oxygenRetailSlice = createSlice({
    name: "oxygenRetail",
    initialState,
    reducers: {
        setCustomermsisdn: (state, {payload}) => {
            state.customermsisdn = payload
        },
        setPreCustomerId: (state, {payload}) => {
            state.preCustomerId = payload
        },
        setBookloanDetails: (state, {payload}) => {
            state.bookloanDetails = payload
        },
        setBookloanLoading: (state, {payload}) => {
            state.bookloanLoading = payload
        },
        setOtpLoading: (state, {payload}) => {
            state.otpLoading = payload
        },
        setPhoneNo: (state, {payload}) => {
            state.phoneNo = payload
        },
        setEmailAddress: (state, {payload}) => {
            state.emailAddress = payload
        },
        setShowForm: (state, {payload}) => {
            state.showForm = payload
        },

        updateAllDevicesPagination: (state, { payload }) => {
            state.devicesParams.PageNumber = payload;
            state.allDevices = [];
        },
        updateAllDevicesSearch: (state, { payload }) => {
            state.devicesParams.Filter = payload;
            state.allDevices = [];
        },
        setUseLivenessCheck: (state, { payload }) => {
            state.useLivenessCheck = payload
        }, 
        setSelectedDevice: (state, { payload }) => {
            state.selectedDevice = payload;
        },
        setTabValue: (state, { payload }) => {
            state.tabValue = payload
        },
        
        setbypassSmileIdLiveCheck : (state, action) => {
        state.bypassSmileIdLiveCheck = action.payload
        },

        updateFBNDevicesPagination: (state, { payload }) => {
            state.devicesParams.PageNumber = payload;
            state.fbnDeviceByTenure = [];
        },
        updateFBNDevicesSearch: (state, { payload }) => {
            state.devicesParams.Filter = payload;
            state.fbnDeviceByTenure = [];
        },
    },

    
    extraReducers: (builder) => {

        // All Banks
        builder.addCase(getAllBanks.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllBanks.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.allBanks = payload;
        });
        builder.addCase(getAllBanks.rejected, (state, {payload}) => {
            state.loading = false;
            state.allBanks = [];
            state.error = "Error, Failed to load banks";
        });

        // Employment status
        builder.addCase(getEmploymentStatus.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getEmploymentStatus.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.employmentStatus = payload;
            state.error = "";
        });
        builder.addCase(getEmploymentStatus.rejected, (state, action) => {
            state.loading = false;
            state.employmentStatus = [];
            state.error = "Error, Failed to load employment status";
        });

        // Financier
        builder.addCase(getFinancier.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getFinancier.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.financiers = payload;
            state.error = "";
        });
        builder.addCase(getFinancier.rejected, (state, action) => {
            state.loading = false;
            state.financiers = [];
            state.error = "Error, Failed to load financiers";
        });

        // PreCustomer By Msisdn
        builder.addCase(getPreCustomerByMsisdn.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getPreCustomerByMsisdn.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.preCustomerDetailsByMsisdn = payload;
            state.error = "";
        });
        builder.addCase(getPreCustomerByMsisdn.rejected, (state, action) => {
            state.loading = false;
            state.preCustomerDetailsByMsisdn = [];
            state.error = "Error, Failed to load preCustomer";
        });

        // Repayment Setup Link
        builder.addCase(getRepaymentSetupLink.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getRepaymentSetupLink.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.repaymentSetupLink = payload;
            state.error = "";
        });
        builder.addCase(getRepaymentSetupLink.rejected, (state, action) => {
            state.loading = false;
            state.repaymentSetupLink = [];
            state.error = "Error, Failed to load repayment setup link";
        });

        // Verify Bundle Activation
        builder.addCase(getVerifyBundleActivation.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getVerifyBundleActivation.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.verifyBundleStatus = payload;
            state.error = "";
        });
        builder.addCase(getVerifyBundleActivation.rejected, (state, action) => {
            state.loading = false;
            state.error = "Error, Failed to verify bundle activation";
        });

        // preCustomer By Msisdn and email
        builder.addCase(getPreCustomerByMsisdnAndEmail.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getPreCustomerByMsisdnAndEmail.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.preCustomerDetailsByMsisdnAndEmail = payload;
            state.error = "";
        });
        builder.addCase(getPreCustomerByMsisdnAndEmail.rejected, (state, payload) => {
            state.loading = false;
            state.preCustomerDetailsByMsisdnAndEmail = payload;
            state.error = "Error, Failed to load preCustomer";
        });

        // precustomer details by precustomerId
        builder.addCase(getPrecustomerDetailsByPreCustomerId.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getPrecustomerDetailsByPreCustomerId.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.preCustomerDetailsByPreCustomerId = payload;
            state.error = "";
        });
        builder.addCase(getPrecustomerDetailsByPreCustomerId.rejected, (state, payload) => {
            state.loading = false;
            state.preCustomerDetailsByPreCustomerId = payload;
            state.error = "Error, Failed to load preCustomer";
        });

        // all devices
        builder.addCase(getAllDevices.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getAllDevices.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.allDevices = payload;
            state.error = "";
        });
        builder.addCase(getAllDevices.rejected, (state, action) => {
            state.loading = false;
            state.allDevices = [];
            state.error = "Error, Failed to load all devices";
        });

        // device by creditlimit
        builder.addCase(getDeviceByCreditLimit.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getDeviceByCreditLimit.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.allDevices = payload;
            state.error = "";
        });
        builder.addCase(getDeviceByCreditLimit.rejected, (state, action) => {
            state.loading = false;
            state.allDevices = [];
            state.error = "Error, Failed to load devices";
        });

        // FBN device by tenure
        builder.addCase(getFBNDeviceByTenure.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getFBNDeviceByTenure.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.fbnDeviceByTenure = payload;
            state.error = "";
        }); 
        builder.addCase(getFBNDeviceByTenure.rejected, (state, action) => {
            state.loading = false;
            state.fbnDeviceByTenure = [];
            state.error = "Error, Failed to load devices";
        });

        // FBN fetch more devices
        builder.addCase(getFBNFetchMoreDevices.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getFBNFetchMoreDevices.fulfilled, (state, {payload}) => {
            state.loading = false;
            state.fbnDeviceByTenure = payload;
            state.error = "";
        }
        ); 
        builder.addCase(getFBNFetchMoreDevices.rejected, (state, action) => {
            state.loading = false;
            state.fbnDeviceByTenure = [];
            state.error = "Error, Failed to load devices";
        });
    }
});


export default oxygenRetailSlice.reducer;
export const { setCustomermsisdn, setPreCustomerId, setBookloanDetails, setBookloanLoading, setOtpLoading, setTabValue,
    setPhoneNo,setEmailAddress,setShowForm, updateAllDevicesPagination, updateAllDevicesSearch, setUseLivenessCheck, setSelectedDevice, 
setbypassSmileIdLiveCheck, updateFBNDevicesPagination, updateFBNDevicesSearch, } = oxygenRetailSlice.actions;